import React from 'react'
import { WhenEnvValueMatches } from '@morningtrain/react-helpers'

export default function WhenDeviceAuthorized ({ children, negate = false }) {
  return (
    <WhenEnvValueMatches name='device.is_authorized' matches negate={negate}>
      {children}
    </WhenEnvValueMatches>
  )
}
